<script setup lang="ts">
import { importLibrary } from '@googlemaps/js-api-loader';
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps<{
  center: google.maps.LatLngLiteral;
  zoom?: number;
  options?: google.maps.MapOptions;
}>();

const emit = defineEmits<{
  (e: 'ready', map: google.maps.Map): void;
}>();

const mapEl = ref<HTMLElement | null>(null);
let map: google.maps.Map | null = null;

function onResize() {
  if (map) {
    google.maps.event.trigger(map, 'resize');
    const center = map.getCenter();
    if (center) map.setCenter(center);
  }
}

onUnmounted(() => {
  map = null;
  removeEventListener('resize', onResize);
});

onMounted(() => {
  importLibrary('maps')
    .then(({ Map }) => {
      if (!mapEl.value) return;

      const defaultOptions: google.maps.MapOptions = {
        center: props.center,
        zoom: props.zoom ?? 17,
        scrollwheel: true,
        disableDefaultUI: true,
      };

      map = new Map(mapEl.value, Object.assign(defaultOptions, props.options));

      addEventListener('resize', onResize);

      emit('ready', map!);
    })
    .catch((err) => {
      if (import.meta.env.DEV)
        console.error('Failed to load Google Maps library', { err });
    });
});
</script>

<template>
  <div ref="mapEl" :class="$style.root" />
</template>

<style lang="scss" module>
.root {
  background: #e6e6e6;
}
</style>
